export enum CallbackTicketCountType {
    Undefined,
    My,
    Team
}
